export const CopyToClipboard = async (content: string) => {
    try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            await navigator.clipboard.writeText(content);
        } else {
            const textField: HTMLTextAreaElement = document.createElement("textarea");
            textField.value = content;
            document.body.appendChild(textField);
            textField.select();
            document.execCommand("copy");
            document.body.removeChild(textField);
        }
    } catch (err) {
        console.error('Failed to copy text: ', err);
    }
}
